export default __webpack_public_path__ + "static/media/folding.f7794ce6.jpg";